import { FiGrid, FiBookOpen, FiUserCheck, FiUsers, FiSettings, FiAlertCircle, FiActivity, FiMail, FiCode, FiCopy } from "react-icons/fi";
import JobDetails from "./JobDetails";
import StepHistory from "./StepHistory";
import Roles from "./Roles";
import Users from "./Users";
import ActivityLog from "./ActivityLog";
import Clients from "./Clients";
import IntegrationInstanceFailure from "./IntegrationInstanceFailure";
import StepHistoryElastic from "./StepHistoryElastic";
import Mail from "./Mail";
import ClientTranslation from "./ClientTranslation";
import ErrorPattern from "./ErrorPattern";
import ErrorPatternEdit from "./ErrorPatternEdit";
import FailureMailConfig from "./FailureMailConfig";
import GlobalVariable from "./GlobalVariable";
import JobActivityLog from "./JobActivityLog";
import ParseTemplate from "./ParseTemplate";
import ScriptTester from "./ScriptTester";
import SystemJobDetail from "./SystemJobDetail";
import SystemJob from "./SystemJob";
import Dashboard from "./Dashboard";
import CloneJob from "./CloneJob";
import ClientSettings from "./ClientSettings";
import RoleEdit from "./RoleEdit";
import UserEdit from "./UserEdit";
import JobRun from "./JobRun";
import JobDetailEdit from "./JobDetailEdit";

export const sidebarItems = [
  {
    key: "DASHBOARD",
    label: "Dashboard",
    path: "/dashboard",
    icon: FiGrid,
    element: <Dashboard />,
    permission: "DASHBOARD",
  },
  {
    key: "JOB_DETAILS",
    label: "Job Details",
    path: "/job-details",
    icon: FiBookOpen,
    element: <JobDetails />,
    permission: "JOB_DETAILS",
  },
  {
    key: "STEP_HISTORY",
    label: "Step History",
    path: "/step-history",
    icon: FiActivity,
    element: <StepHistory />,
    permission: "STEP_HISTORY",
  },
  {
    key: "STEP_HISTORY_ELASTIC",
    label: "Step History Elastic",
    path: "/step-history-elastic",
    icon: FiActivity,
    element: <StepHistoryElastic />,
    permission: "STEP_HISTORY_ELASTIC",
  },
  {
    key: "INTEGRATION_INSTANCE_FAILURE",
    label: "Integration Failures",
    path: "/integration-failure",
    icon: FiAlertCircle,
    element: <IntegrationInstanceFailure />,
    permission: "INTEGRATION_INSTANCE_FAILURE",
  },
  {
    key: "JOB_RUN_DETAIL",
    label: "Job Run",
    path: "/job-run-detail",
    icon: FiActivity,
    element: <JobRun />,
    permission: "JOB_RUN_DETAIL",
  },
  {
    key: "MAIL",
    label: "Mail",
    path: "/mail",
    icon: FiMail,
    element: <Mail />,
    permission: "MAIL",
  },
  {
    key: "CLIENT_TRANSLATION",
    label: "Client Translation",
    path: "/client-translation",
    icon: FiSettings,
    element: <ClientTranslation />,
    permission: "CLIENT_TRANSLATION",
  },
  {
    key: "GLOBAL_VARIABLE",
    label: "Global Variable",
    path: "/global-variable",
    icon: FiSettings,
    element: <GlobalVariable />,
    permission: "GLOBAL_VARIABLE",
  },
  {
    key: "CLIENTS",
    label: "Clients",
    path: "/clients",
    icon: FiUsers,
    element: <Clients />,
    permission: "CLIENTS",
  },
  {
    key: "USERS",
    label: "Users",
    path: "/users",
    icon: FiUsers,
    element: <Users />,
    permission: "USERS",
  },
  {
    key: "ROLES",
    label: "Roles",
    path: "/roles",
    icon: FiUserCheck,
    element: <Roles />,
    permission: "ROLES",
  },
  {
    key: "PARSE_TEMPLATE",
    label: "Parse Template",
    path: "/parse-template",
    icon: FiBookOpen,
    element: <ParseTemplate />,
    permission: "PARSE_TEMPLATE",
  },
  {
    key: "SCRIPT_TESTER",
    label: "Script Tester",
    path: "/script-tester",
    icon: FiCode,
    element: <ScriptTester />,
    permission: "SCRIPT_TESTER",
  },
  {
    key: "ACTIVITY_LOG",
    label: "Activity Log",
    path: "/activity-log",
    icon: FiActivity,
    element: <ActivityLog />,
    permission: "ACTIVITY_LOG",
  },
  {
    key: "FAILURE_MAIL_CONFIG",
    label: "Failure Mail Config",
    path: "/failure-mail-config",
    icon: FiMail,
    element: <FailureMailConfig />,
    permission: "FAILURE_MAIL_CONFIG",
  },
  {
    key: "JOB_ACTIVITY_LOG",
    label: "Job Activity Log",
    path: "/job-activity-log",
    icon: FiActivity,
    element: <JobActivityLog />,
    permission: "JOB_ACTIVITY_LOG",
  },
  {
    key: "ERROR_PATTERN",
    label: "Error Pattern",
    path: "/error-pattern",
    icon: FiAlertCircle,
    element: <ErrorPattern />,
    permission: "ERROR_PATTERN",
  },
  {
    key: "SYSTEM_JOB_DETAIL",
    label: "System Job",
    path: "/system-job-detail",
    icon: FiGrid,
    element: <SystemJobDetail />,
    permission: "SYSTEM_JOB_DETAIL",
  },
  {
    key: "CLONE_JOB",
    label: "Clone Jobs",
    path: "/clone-job",
    icon: FiCopy,
    element: <CloneJob />,
    permission: "CLONE_JOB",
  },
];

// Additional routes that are not in sidebar
export const additionalRoutes = [
  {
    key: "CLIENT_SETTINGS",
    label: "Client Settings",
    path: "/clientSettings/:clientId",
    element: <ClientSettings />,
    permission: "CLIENTS", // Use same permission as Clients
  },
  {
    key: "ROLE_EDIT",
    label: "Role Edit",
    path: "/roleEdit/:roleId",
    element: <RoleEdit />,
    permission: "ROLES", // Use same permission as Roles
  },
  {
    key: "USER_EDIT",
    label: "User Edit",
    path: "/userEdit/:userId",
    element: <UserEdit />,
    permission: "USERS", // Use same permission as Users
  },
  {
    key: "SYSTEM_JOB_EDIT",
    label: "System Job Edit",
    path: "/system-job/:id",
    element: <SystemJob />,
    permission: "SYSTEM_JOB_DETAIL_EDIT", // System job detail edit screen view and edit
  },
  {
    key: "JOB_DETAIL_EDIT",
    label: "Job Detail Edit",
    path: "/job-detail-edit/:id",
    element: <JobDetailEdit />,
    permission: "JOB_DETAIL_EDIT", // Admin only; client users restricted to job list view
  },
  {
    key: "ERROR_PATTERN_EDIT",
    label: "Error Pattern Edit",
    path: "/error-pattern-edit/:id",
    element: <ErrorPatternEdit />,
    permission: "ERROR_PATTERN", // Use same permission as Error Pattern
  },
]; 